import React from 'react';
import { Modal, Button } from 'antd';

export default function OrderSendToQcModal({
  open,
  onCancel,
  onConfirmYes,
  onConfirmNo,
  order,
  loading,
}) {
  return (
    <Modal
      title="Send to QC team"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="yes"
          type="primary"
          onClick={onConfirmYes}
          loading={loading}
          className="app-btn-primary"
        >
          Yes, send to QC
        </Button>,
        <Button
          key="no"
          onClick={onConfirmNo}
          loading={loading}
          className="app-btn-cancel"
        >
          No, keep pending
        </Button>,
      ]}
      destroyOnClose
    >
      {order && (
        <>
          Are you sure you want to send this order to QC team?
          {order.orderNumber && (
            <> (Order <strong>{order.orderNumber}</strong>)</>
          )}
        </>
      )}
    </Modal>
  );
}
